/**
 * The one definition of the vendor director minimum. Plain data in, number out —
 * no import of config/ — so both useDirectorsSection and the readiness meter
 * judge the Directors section by the same number instead of two expressions
 * that can drift apart.
 */
export function directorMinFor(capabilities: Record<string, unknown>, systemType: string): number {
  const raw = systemType === 'Expansion' ? capabilities.expansionDirectorCountMin : capabilities.directorCountMin;
  return typeof raw === 'number' ? raw : 3;
}
